import { render, staticRenderFns } from "./StudentCourseList.vue?vue&type=template&id=87156a06&scoped=true"
import script from "./StudentCourseList.vue?vue&type=script&lang=js"
export * from "./StudentCourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87156a06",
  null
  
)

export default component.exports